export class LoanBuilder {
  constructor() {
    this.loanType = '30 year fixed'; // potentially empty
    this.loanProgram = 'Conventional'; // potentially empty, TODO: 'VA'
    this.loanTerm = 360; // potentially empty
  }
}
